import {ChangeDetectorRef, Component, ComponentFactoryResolver, ViewChild, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from '../../../model/api/field-record';
import {FormFieldConfig} from '../../../model/api/form-field-config';
import {CommonFieldService} from '../../../services/common/common-field.service';
import {CrudBaseComponent} from '../../../crystal-elements/crud/crud-base.component';
import {SchedulerService} from '../../../services/tools/scheduler.service';
import {NotificationService} from "../../../services/security/notification.service";
import {FieldRequest} from "../../../model/api/field-request";
import {Notification} from "../../../model/security/notification";
import {CrudTableComponent} from "../../../crystal-elements/crud/crud-table.component";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class NotifyComponent extends CrudBaseComponent<Notification> {

  // fields
  users: FieldRecord<any>[] = [];
  types: FieldRecord<any>[] = [];
  selectedTypes: any = [];

  @ViewChild('crudTable')
  public crudTable: CrudTableComponent;

  constructor(cdref: ChangeDetectorRef,
              commonFieldService: CommonFieldService,
              private notificationService: NotificationService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = notificationService;
    this.fieldId = 'title';
    this.transPartKey = 'tools.notify';

    this.prepareForCreate = this.prepareRecordForCreate;
    this.prepareForClone = this.prepareRecordForClone;
    this.prepareSelectedIds = this.prepareRecordSelectedIds;
  }

  protected initConfigs() {
    super.initConfigs();

    this.initTableColumns();
    this.initFormFields();
  }

  private initTableColumns() {
    this.tableConfig = [];
    this.tableConfig.push(
      {
        field: 'type',
        width: 80,
        icon: value => this.notificationService.getIconForNotification(value),
        notFilterable:true
      },
      {
        field: 'content',
        class: record => 'ql-editor ql-cc-container',
        mapId: record => record.content ? record.content : '',
        // toolTip: record => record.content ? record.content : ''
        width: 500,
      },
      {
        field: 'usernames',
        toolTip: record => record.usernames ? record.usernames.join(',') : '',
        mapId: record => record.usernames ? record.usernames.join(',') : '',
        width: 200,
      },
      {
        field: 'dateCreation',
        format: 'dd/MM/yyyy hh:mm',
        type: 'DATE',
        notFilterable:true
      });
  }

  private initFormFields() {
    this.formConfig = [];
    this.formConfig.push({
      group: '',
      fields: [{
        field: 'usernames',
        required: true,
        column: 6,
        type: TYPE.MULTISELECT,
        options: () => this.users,
        filter: true
      }, {
        field: 'type',
        required: true,
        column: 6,
        type: TYPE.DROPDOWN,
        options: () => this.types,
        icon: id => this.notificationService.getIconForNotificationType(Notification.TYPE[id]),
      },
        {
          field: 'content',
          required: true,
          column: 12,
          type: TYPE.RICHTEXTAREA,
        }]
    });
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;
    this.types = [];
    this.types.push(new FieldRecord(Notification.TYPE.RELEASE, Notification.TYPE.RELEASE.toLowerCase()));
    this.types.push(new FieldRecord(Notification.TYPE.ALERT, Notification.TYPE.ALERT.toLowerCase()));
    this.selectedTypes = [...this.types]
    this.commonFieldService.getSecurityUsers(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.users = this.getFields(fieldResult);
      this.settingsFormLoadingProgressValue += 100;
    });
  }

  onFormShow() {

  }

  onSaved() {

  }

  clearFilters() {
    this.selectedTypes = [this.types];
  }

  tableCurrentRequestChanged() {
    if (this.tableCurrentRequest) {
      let typeFilter = this.tableCurrentRequest.filters2.find(value => value.field == 'type');
      if (!typeFilter) {
        typeFilter = {
          field: 'type',
          matchMode: 'in',
          operator: 'and'
        };
        this.tableCurrentRequest.filters2.push(typeFilter);
      }
      if (this.selectedTypes.length > 0)
        typeFilter.value = this.selectedTypes.map(value => value.id).join(',');
      else
        typeFilter.value = undefined;
      queueMicrotask(() => {
        if (this.crudTable)
          this.crudTable.ccFormDialog.reloadFieldValueMap();
      });
    }
  }

  filterChanged() {
    this.tableCurrentRequestChanged();
    this.loadRecords(this.tableCurrentRequest);
    // this.crudTable.refreshContextMenu();
  }

  prepareRecordForClone(): void {
    if (this.formRecord) {
      this.formRecord.ids = undefined;
    }
  }

  prepareRecordForCreate(): void {
    if (this.formRecord) {
        this.formRecord.usernames = this.users.map(value => value.id);
      this.formRecord.type = Notification.TYPE.RELEASE;
    }
  }

  prepareRecordSelectedIds(): string[] {
    const ids: number[] = [];
    this.selectedRecords.forEach(record => ids.push(...record.ids))
    return ids.map(value => value + '');
  }
}
